<div class="card">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">assignment</i>
    </div>
    <h4
      style="cursor: pointer"
      (click)="containerByPhysicalDestruction()"
      class="card-title"
    >
      Physical Destruction Report
      <i class="material-icons">toggle_on</i>
    </h4>
  </div>
  <div class="card-body">
    <div class="row" *ngIf="statusContainerByPhysicalDestruction">
      <div class="col-md-12">
        <form>
          <!--<input type="text" [readonly]="currentReport" placeholder="Enter Client's Name" class="form-control" [(ngModel)]="this.destructionclientsname" name="destructionclientsname" >-->
          <!-- <input type="text" [readonly]="currentReport" placeholder="Enter PO#" class="form-control" [(ngModel)]="this.destructionpo" name="destructionpo" >-->
          <div class="row">
            <div class="col-9">
              <div class="form-group">
                <mat-form-field class="example-full-width">
                  <input
                    type="text"
                    [(ngModel)]="destructionclientscompany"
                    placeholder="Company Name"
                    aria-label="Company Name"
                    matInput
                    [formControl]="myControlCompaniesDestruction"
                    [matAutocomplete]="autoCompaniesDestruction"
                    id="nameCompanyDestruction"
                    required
                  />
                  <mat-autocomplete
                    (optionSelected)="OnHumanSelectedDestruction($event.option)"
                    #autoCompaniesDestruction="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="
                        let option of filteredCompaniesDestruction | async
                      "
                      [value]="option.name"
                    >
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <input
                  type="text"
                  placeholder="Company Name"
                  class="form-control"
                  [(ngModel)]="destructionclientscompany2"
                  name="companyInput"
                  id="companyInput"
                  style="display: none"
                  readonly
                />
              </div>
            </div>
            <div class="col-3">
              <mat-radio-group
                class="example-radio-group"
                name="trep"
                [(ngModel)]="typeReport"
                (change)="clean()"
              >
                <mat-radio-button class="example-radio-button" value="basic">
                  Basic PDR
                </mat-radio-button>
                &nbsp;&nbsp;
                <mat-radio-button class="example-radio-button" value="detail">
                  Detailed PDR
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>PO#</label>
                <select
                  (change)="selectChangeHandlerDestruction($event)"
                  id="poform"
                  name="hdlinkposelect"
                  [(ngModel)]="this.destructionpo"
                  #hdlinkposelect="ngModel"
                  placeholder="Client Name"
                  class="form-control"
                  required
                >
                  <option value="">Select PO#</option>
                  <option *ngFor="let po of poListDestruction" [value]="po.po">
                    {{ po.po }}
                  </option>
                </select>
                <input
                  type="hidden"
                  placeholder="PO"
                  class="form-control"
                  [(ngModel)]="destructionposelected"
                  name="poInputDestruction"
                  id="poInputDestruction"
                  style="display: none"
                  readonly
                />
              </div>
            </div>
            <div class="col-3"></div>
            <div class="col-3"></div>
            <div class="col-3"></div>
          </div>

          <div class="row">
            <div class="col-12" *ngIf="typeReport === 'detail'">
              <label>Make</label>
              <input
                *ngIf="destructionpo !== '' && destructionpo !== null"
                type="text"
                class="form-control"
                [(ngModel)]="this.destructionManuallyMake"
                name="make"
              />
            </div>
            <div class="col-12" *ngIf="typeReport === 'detail'">
              <label>Model</label>
              <input
                *ngIf="destructionpo !== '' && destructionpo !== null"
                type="text"
                class="form-control"
                [(ngModel)]="this.destructionManuallyModel"
                name="model"
              />
            </div>
            <div class="col-12" *ngIf="typeReport === 'detail'">
              <label>Capacity</label>
              <input
                *ngIf="destructionpo !== '' && destructionpo !== null"
                type="text"
                class="form-control"
                [(ngModel)]="this.destructionManuallySerialCapacity"
                name="capacity"
              />
            </div>
            <div class="col-12">
              <label>Serial Number</label>
              <input
                *ngIf="destructionpo !== '' && destructionpo !== null"
                type="text"
                class="form-control"
                [(ngModel)]="this.destructionManuallySerialNumber"
                name="advancedsearchtext"
              />
            </div>
          </div>

          <!--   <button style="display: none" class="btn btn-info" (click)="searchDestructionReport()">Search </button> <button style="display:none" class="btn btn-success" (click)="showDestructionManually()">Add Manually</button>-->
          <button
            *ngIf="!cerrado && destructionpo !== '' && destructionpo !== null"
            [disabled]="
              destructionclientscompany == '' ||
              destructionManuallySerialNumber == '' ||
              saving
            "
            class="btn btn-success"
            (click)="saveDestructionReport()"
          >
            <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            &nbsp; Add To Report
          </button>

          <button
            *ngIf="
              this.responseDestructionReport.length > 0 &&
              this.destructionpo != '' &&
              !cerrado
            "
            class="btn btn-success"
            (click)="generateDestructionReport()"
          >
            Generate Destruction Report
          </button>
        </form>

        <form *ngIf="this.destructionShowAddManually">
          <div class="col-md-6">
            <input
              type="text"
              placeholder="SerialNumber"
              class="form-control"
              [(ngModel)]="this.destructionManuallySerialNumber"
              name="advancedsearchtext"
            />
          </div>
          <div class="col-md-6">
            <input
              type="text"
              placeholder="Date"
              class="form-control"
              [(ngModel)]="this.destructionManuallyDate"
              name="advancedsearchtext"
            />
          </div>

          <button
            *ngIf="!cerrado"
            class="btn btn-success"
            (click)="AddDestructionManually()"
          >
            Add To Report
          </button>
        </form>

        <div
          id="destructionshowMsgSearching"
          style="display: none"
          class="alert alert-info"
          role="alert"
        >
          <i style="color: white" class="material-icons">sync</i>
          Please wait, searching in progress
        </div>

        <div
          *ngIf="this.destructionshowMsgInfoResults == 1"
          id="destructionshowMsgInfoResults"
          class="alert alert-info"
          role="alert"
        >
          <i style="color: white" class="material-icons">cancel</i>
          This element already exists in the report.
        </div>

        <div
          *ngIf="this.destructionshowMsgSearchingNotResults == 1"
          id="destructionshowMsgSearchingNotResults"
          class="alert alert-danger"
          role="alert"
        >
          <i style="color: white" class="material-icons">cancel</i>
          {{ msgerrordestruction }}
        </div>

        <div
          *ngIf="this.destructionshowMsgSearchingFailedResults == 1"
          id="destructionshowMsgSearchingFailedResults"
          class="alert alert-warning"
          role="alert"
        >
          <i style="color: white" class="material-icons">cancel</i>
          {{ msgerrordestruction }}
        </div>
      </div>
    </div>

    <div
      [hidden]="responseDestructionReport.length === 0"
      class="row"
      style="display: none"
      id="destructionhdresults"
    >
      <div class="col-md-12" style="line-height: 30px">
        <div class="row">
          <div class="col-md-12">
            <h3>
              #{{ responseDestructionReport.length }} Elements for Destruction
              Report #{{ this.destructionpo }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1 bg-light">ID</div>
          <div [ngClass]="{'col-md-4': typeReport !== 'detail', 'col-md-2': typeReport === 'detail'}" class="bg-light">Serial Number</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-2 bg-light">Make</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-2 bg-light">Model</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-1 bg-light">Capacity</div>
          <div [ngClass]="{'col-md-3': typeReport !== 'detail', 'col-md-2': typeReport === 'detail'}" class="bg-light">Destruction Method</div>
          <div [ngClass]="{'col-md-2': typeReport !== 'detail', 'col-md-1': typeReport === 'detail'}" class="bg-light">REP</div>
          <div [ngClass]="{'col-md-2': typeReport !== 'detail', 'col-md-1': typeReport === 'detail'}" class="col-md-3 bg-light" style="display: none">
            Date Destroyed
          </div>
          <div [ngClass]="{'col-md-2': typeReport !== 'detail', 'col-md-1': typeReport === 'detail'}" class="col-md-2 bg-light">Actions</div>
        </div>
        <div
          class="row"
          *ngFor="let row of this.responseDestructionReport; index as i"
          style="border-top: 1px solid #eee"
        >
          <div class="col-md-1">
            <strong>{{ i + 1 }}</strong>
          </div>
          <div [ngClass]="{'col-md-4': typeReport !== 'detail', 'col-md-2': typeReport === 'detail'}">{{ row.SerialNumber }}</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-2">{{ row.make || '' }}</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-2">{{ row.model || '' }}</div>
          <div *ngIf="typeReport === 'detail'" class="col-md-1">{{ row.capacity || '' }}</div>
          <div [ngClass]="{'col-md-3': typeReport !== 'detail', 'col-md-2': typeReport === 'detail'}">Shredded</div>
          <div [ngClass]="{'col-md-2': typeReport !== 'detail', 'col-md-1': typeReport === 'detail'}">{{ row.user }}</div>
          <!-- <div [ngClass]="{'col-md-3': typeReport !== 'detail', 'col-md-2': typeReport === 'detail'}" style="font-weight: bold" style="display: none">
            {{ row.ErasureEndDate }}
          </div> -->
          <div [ngClass]="{'col-md-2': typeReport !== 'detail', 'col-md-1': typeReport === 'detail'}">
            <a
              class="btn btn-link btn-danger btn-just-icon"
              (click)="removeDisk(row.id)"
            >
              <i class="material-icons">delete</i>
            </a>
          </div>
        </div>
      </div>

      <div [hidden]="responseDestructionReport.length === 0" class="clearfix"></div>
      <nav [hidden]="responseDestructionReport.length === 0" aria-label="...">
        <div style="display: inline-flex; width: 100%; position: relative">
          <mat-form-field style="max-width: 90px">
            <mat-select
              (selectionChange)="goToPage(1)"
              placeholder="Showing"
              name="showing"
              [(ngModel)]="perPage"
              ariaLabel="itemsPerPageSelected"
            >
              <!-- <mat-option value="5">5</mat-option> -->
              <!-- <mat-option value="10">10</mat-option> -->
              <!-- <mat-option value="25">25</mat-option> -->
              <!-- <mat-option value="50">50</mat-option> -->
              <!-- <mat-option value="100">100</mat-option> -->
              <mat-option value="150">150</mat-option>
              <!-- <mat-option value="200">200</mat-option> -->
              <mat-option value="500">500</mat-option>
              <mat-option value="1000">1000</mat-option>
              <mat-option value="ALL">ALL</mat-option>
            </mat-select>
          </mat-form-field>
          <p style="align-self: flex-end; margin-left: 30%">
            Showing {{ showingNav }} to {{ showingTo }} of
            {{ total_items_count }} entries
          </p>

          <ul class="pagination" style="position: absolute; right: 0">
            <div style="display: flex">
              <li class="page-item">
                <a
                  (click)="goToPage(1)"
                  *ngIf="page > 1"
                  class="page-link"
                  tabindex="-1"
                  >First</a
                >
              </li>
              <li class="page-item">
                <a
                  (click)="goToPage(page - 1)"
                  *ngIf="page > 1"
                  class="page-link"
                  tabindex="-1"
                  >Previous</a
                >
              </li>
              <li *ngFor="let p of pages" class="page-item">
                <a
                  [className]="page == p + 1 ? 'selected-page' : 'page-link'"
                  (click)="goToPage(p + 1)"
                  >{{ p + 1 }}</a
                >
              </li>
              <li class="page-item">
                <a
                  class="page-link"
                  *ngIf="page < total_pages"
                  (click)="goToPage(page + 1)"
                  >Next</a
                >
              </li>
              <li class="page-item">
                <a
                  (click)="goToPage(total_pages)"
                  *ngIf="page < total_pages"
                  class="page-link"
                  tabindex="-1"
                  >Last</a
                >
              </li>
            </div>
          </ul>
        </div>
      </nav>

      <h3 style="font-weight: 500; margin-left: 20px">Report Summary</h3>

      <ul>
        <li
          style="font-size: 1.2rem"
          *ngFor="let item of summaryTotal | keyvalue"
        >
          <b>{{ item.key }}</b
          >: <b>{{ item.value }}</b>
        </li>
      </ul>
    </div>

    <div
      *ngIf="reportSaved == 1"
      id="reportSaved"
      class="alert alert-info"
      role="alert"
    >
      <i style="color: white" class="material-icons">check</i> Report have been
      saved.
    </div>

    <button
      *ngIf="canUnlock() && cerrado"
      class="btn btn-danger"
      (click)="unlock()"
      [disabled]="saveunlock"
    >
      <i *ngIf="saveunlock" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
      Unlock
    </button>
    <!-- <button *ngIf="this.responseDestructionReport.length > 0 && this.destructionclientsname != '' && this.destructionpo != ''" class="btn btn-success" (click)="saveDestructionReport()" ><i class="material-icons">save</i> Save</button>-->
  </div>
</div>
